<div class="chart-container">     
    <canvas [id]="id" id="id" ></canvas>    
</div>
